import { component } from "picoapp";
import { getSelectedVariant } from "../lib/utils";

export default component((node, ctx) => {
  const bundles = [
    "pan",
    "bowls",
    "plates",
    "side-plates",
    "glasses",
    "trio",
    "perfect-pot",
  ];
  let checkedValue = null;
  let shippingNote = null;

  for (let j = 0; j < bundles.length; j++) {
    const inputElements = document.getElementsByClassName(bundles[j]);
    if (inputElements.length > 0) {
      for (let i = 0; inputElements[i]; ++i) {
        if (inputElements[i].checked) {
          checkedValue = inputElements[i].value;
          break;
        }
      }

      document.getElementById(`js-${bundles[j]}`).innerHTML = checkedValue;
    }
  }

  // fire initial selected variant
  document.querySelectorAll(".checkbox:checked").forEach((el) => {
    const variantId = parseInt(el.dataset.vid);
    const handle = el.dataset.handle;
    getSelectedVariant(handle, variantId);
  });

  const checkboxes = node.querySelectorAll(".checkbox");
  /* eslint-disable no-loop-func */
  for (let i = 0; i < checkboxes.length; i++) {
    checkboxes[i].addEventListener("change", (event) => {
      const name = event.target.getAttribute("name");
      const inputElements = document.querySelectorAll(`input.${name}`);
      const handle = event.target.dataset.handle;

      getSelectedVariant(handle, parseInt(event.target.dataset.vid));

      for (let j = 0; inputElements[j]; ++j) {
        if (inputElements[j].checked) {
          checkedValue = inputElements[j].value;
          shippingNote = inputElements[j].dataset.shippingnote;
          break;
        }
      }

      const variantSelectedEvent = new CustomEvent("variant-selected:id", {
        detail: {
          product: name,
          variant: event.target.dataset.vid,
          bundleHandle: node.dataset.bundleHandle,
          variantName: event.target.id,
        },
      });
      window.dispatchEvent(variantSelectedEvent);

      document.getElementById(`js-${name}-description`).innerHTML =
        event.target.dataset.description;
      document.getElementById(`js-${name}`).innerHTML = checkedValue;
      document.getElementById(`js-${name}-shippingnote`).innerHTML =
        shippingNote;
    });
  }

  // fire off change event to trigger state change (gallery slides etc...)
  // according to permalink URL params
  const checkedRadios = document.querySelectorAll(".checkbox:checked");
  const checkedRadiosArray = [...checkedRadios];

  window.addEventListener("product-carousel:mounted", () =>
    checkedRadiosArray.reverse().forEach((el) => {
      el.dispatchEvent(new Event("change", { bubbles: true }));
    })
  );
});
